import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PatientAmmendmentsNoteComponent } from '../patient-portal/patient-ammendments-note/patient-ammendments-note.component';
import { PPBookAppointmentComponent } from '../patient-portal/ppbook-appointment/ppbook-appointment.component';
import { PPDemographicsRequestComponent } from '../patient-portal/ppdemographics-request/ppdemographics-request.component';
import { PPEmergencyRequestComponent } from '../patient-portal/ppemergency-request/ppemergency-request.component';
import { PPInsuranceRequestComponent } from '../patient-portal/pp_InsuranceRequest/pp-insurance-request/pp-insurance-request.component';
import { DirectMessagesComponent } from './direct-messages/direct-messages.component';
import { DmProviderSearchComponent } from './dm-provider-search/dm-provider-search.component';
import { MessageHomeComponent } from './message-home/message-home.component';
import { MessageInboxComponent } from './message-inbox/message-inbox.component';
import { PatientRequestInformationComponent } from './patient-request-information/patient-request-information.component';
import { TasksandMessagesComponent } from './tasksand-messages/tasksand-messages.component';
import { ViewMessagesComponent } from './view-messages/view-messages.component';

const routes: Routes = [
  { path: 'viewmessage/:id', component: ViewMessagesComponent },
  { path: 'message', component: MessageHomeComponent },
  { path: 'messageInbox', component: MessageInboxComponent },
  { path: 'directMessages', component: DirectMessagesComponent },
  // { path: 'patientRequestInformation', component: PatientRequestInformationComponent },
  { path: 'patientRequestInformation/:linkId/:MessageType', component: PatientRequestInformationComponent },
  // { path: 'Demographics/Personal/:linkId/:MessageType', component: PersonalDetailsComponent },
  { path: 'InsuranceRequest/:linkId/:insuranceId/:RequestType', component: PPInsuranceRequestComponent },
  { path: 'insuranceRequest/:linkId', component: PPInsuranceRequestComponent },
  { path: 'PPBookAppointment/:linkid', component: PPBookAppointmentComponent },
  { path: 'PPDemographics/:linkId', component: PPDemographicsRequestComponent },
  { path: 'EmergencyRequest/:linkId/:emergencyId/:RequestType', component: PPEmergencyRequestComponent },
  { path: 'tasksandmessages/:screen', component: TasksandMessagesComponent },
  { path: 'tasksandmessages', component: TasksandMessagesComponent },
  { path: 'PPAmmendmentNote/:linkId', component: PatientAmmendmentsNoteComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  entryComponents: [
    DmProviderSearchComponent
  ]
})
export class MessagesRoutingModule { }
